<template>
  <vx-card class="welcome">
    <div class="vx-col w-full mb-base">
      <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
<!--          <img src="@/assets/images/pages/404.png" alt="graphic-404" class="mx-auto mb-4 max-w-full">-->
          <h1 class="sm:mx-0 mx-4 text-6xl d-theme-text-inverse">ยินดีต้อนรับเข้าสู่<br/>โปรแกรมระบบขยะ</h1>
        </div>
      </div>
    </div>
  </vx-card>
</template>
<script>
  import moduleInvoiceDate from "@/store/invoice-date/moduleInvoiceDate.js";
  import moment from "moment";

  export default {
    components: {
    },
    data() {
      return {
        currentDate: new Date(),
      }
    },
    computed: {
      invoiceData() {
        return this.$store.state.invoiceDate.items;
      }
    },
    methods: {
      formatToThaiDate(val, format) {
        'use strict'
        // const date = moment(text).format('DD/MM/YYYY');
        // const dateSplit = date.split('/');
        // const year = parseInt(dateSplit[2]) + 543;
        // return dateSplit[0] + '/' + dateSplit[1] + '/' + year;
        const date = moment(val).locale("th");
        date.add(543, "years");
        return date.format(format);
      },
      goToSetPaymentDialog(date) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'คำเตือน',
          text: `ท่านยังไม่ได้กำหนดรอบส่งเงิน (ปัจจุบันรอบส่งเงินคือวันที่ ${date}) หากท่านไม่กำหนดรอบจะไม่สามารถรับชำระเงินได้`,
          acceptText: 'กำหนดรอบส่งเงิน',
          cancelText: 'ยังก่อน',
          accept: this.goToSetPayment,
          cancel: this.showDisclaimer
        })
      },
      confirmChangeBill(IsChanged, currentInvoiceDate) {
        this.$vs.dialog({
          type: 'alert',
          title: `ข้อกำหนดการใช้งานโปรแกรม`,
          text: 'แจ้งเพื่อทราบ​  โปรแกรมขยะ​ On​  Mobile​ออกแบบมาเพื่อใหัการทำงานของเจ้าหน้าที่สะดวกขึ้นและเพื่อป้องกันการทุจริต​  ถ้าทางเราตรวจพบเจ้าหน้าที่ไม่ ทำตามขั้นตอนในคู่มือที่ได้อบรมไป​   โดยไม่ พิมพ์ รายงานป.32 ประจำวันออกจากโปรแกรมหน้าเว็บ และไม่พิมพ์ใบเสร็จตัวจริงสีเขียว ตามป.32 ประจำวัน ไม่บันทึกเลขที่ใบเสร็จ เพื่อให้พิมพ์ในป. 32 ประจำวัน และไม่ฉีกต้นขั้ว ใบเสร็จสีเขียวไว้ให้สตง.ตรวจภายหลัง ทางเราจะ ระงับการใช้งานโปรแกรมชั่วคราวโดยไม่จำเป็นต้องแจ้งให้ทราบก่อนล่วงหน้า​ และ ผอ.กองคลัง จะต้องกำหนด User ที่เข้าใช้งานและเข้าตรวจสอบ การส่งเงิน ให้มีรหัสของใครของคนนั้น และจะต้องมี User ที่เป็น เจ้าหน้าที่ที่เป็นข้าราชการ เพื่อจะได้เข้าไปตรวจสอบการทำงานได้ เพื่อเป็นการป้องกันการทุจริต หากเกิดความไม่สะดวกต้องขออภัยมาณ.ที่นี้ด้วยครับ หากมีปัญหาขัดข้องประการใด ให้เป็นเพื่อนทางไลน์​ OA​ และติดต่อ ส่งข้อความ มาทางไลน์ เท่านั้นครับ',
          accept: ()=>{
            if(IsChanged){
              this.goToSetPaymentDialog(this.formatToThaiDate(currentInvoiceDate, 'D MMMM YYYY'))
            }else{
              this.$vs.dialog.dismiss
            }
          },
          acceptText: 'รับทราบ'
        })
      },
      goToSetPayment() {
        this.$router.push('/operation/set_payment')
      },
    },
    async created() {
      this.$vs.loading();
      if (!moduleInvoiceDate.isRegistered) {
        this.$store.registerModule('invoiceDate', moduleInvoiceDate)
        moduleInvoiceDate.isRegistered = true
      }
      await this.$store.dispatch("invoiceDate/fetchCurrentDataListItems").then((res) => {
        if (res.status === 200 && res.data) {
          const currentInvoiceDate = moment(res.data.invoice_date).format('YYYY-MM-DD')
          const currentDate = moment().format('YYYY-MM-DD')
          this.confirmChangeBill(currentInvoiceDate < currentDate, currentInvoiceDate);
        } else {
          this.$vs.loading.close();
        }
      }).catch((error) => {
        this.$vs.loading.close();
      });
      this.$vs.loading.close();
    }
  }
</script>
<style>
  .welcome {
    background-image: url("../assets/images/pages/garbage_bg.jpg");
    background-repeat: no-repeat;
    background-size: cover;
  }
</style>
